import {
  MemoryRouter,
  HashRouter,
  Routes,
  Route,
} from "react-router-dom"
import { AppContextProvider } from "./AppContext"
import config from './config'

import LeadForm from './Components/LeadForm'

export default function App(props) {
  return (
    <MemoryRouter>
      <AppContextProvider form={props.form}>
        <Routes>
          <Route exact path="/" element={<LeadForm
            flows={config.flows}
          />}/>
        </Routes>
      </AppContextProvider>
    </MemoryRouter>
  )
}
